<template>
  <div>
    <BlBackdrop
      label="Create"
      :disabled="isDisabledSubmit"
      @backdrop-close="$emit('close-modal')"
      @backdrop-action="onNext"
    >
      <div
        class="px-8 pt-8 pb-4 flex flex-col gap-2"
        :style="{ width: '40rem' }"
      >
        <BlTextBody2
          v-if="isOpenRoom"
          text="Open room"
          class="text-slate-600"
        />
        <BlTextTitle4 text="Create new appointment" />
        <BlTextBody2
          v-if="isOpenRoom"
          text="All therapists are available for booking in this room, as long as they have no conflicting appointments during the time slot selection."
          class="text-slate-800"
        />
      </div>
      <div
        class="overflow-y-auto"
        :style="{
          width: '40rem',
          maxHeight: isOpenRoom ? 'calc(100vh - 18rem)' : 'calc(100vh - 14rem)'
        }"
      >
        <div class="px-8 flex flex-col gap-4 mb-4">
          <div class="flex items-center gap-2">
            <BlIcon icon="user-square" color="slate-6" class="w-6 h-6" />
            <BlSearchSelect
              class="max-w-136"
              v-model="clientInput"
              placeholder="Select client"
              :fetchProperty="{
                url: `/api/v1/clients?sort=alphabetical&status=active${
                  therapistInput ? `&user_id=${therapistInput}` : ``
                }&query=`,
                dataKey: 'clients',
                countKey: 'total_clients',
                optionKeys: { value: 'id', label: 'name' }
              }"
              @change="onChangeClient"
            />
          </div>
          <div v-if="!isOpenRoom" class="flex items-center gap-2">
            <BlIcon icon="user" color="slate-6" class="w-6 h-6" />
            <BlSelectBox
              class="max-w-136"
              v-model="therapistInput"
              :placeholder="
                therapistSelectLoading ? 'Loading ...' : 'Select therapist'
              "
              :options="therapistOptions"
              search
              :disabled="therapist.id !== null"
              @change="onChangeTherapist"
            />
          </div>
          <div class="flex items-center gap-2">
            <BlIcon icon="calendar-blank" color="slate-6" class="w-6 h-6" />
            <BlInputDate
              class="flex-grow"
              :input="startDateInput"
              @changed="onChangeDate"
            />
          </div>
          <div class="flex items-center gap-2">
            <BlIcon icon="clock-outline" color="slate-6" class="w-6 h-6" />
            <BlSelectTimeslot
              class="flex-grow"
              v-model="timeInput"
              :placeholder="
                timeSelectLoading ? 'Loading...' : 'Select timeslot'
              "
              :options="timeOptions"
              @change="onChangeTimeSlot"
            />
            <!-- :disabled="!therapistInput || !startDateInput.model || !roomInput" -->
          </div>
          <div v-if="isOpenRoom" class="flex items-center gap-2">
            <BlIcon icon="user" color="slate-6" class="w-6 h-6" />
            <BlSelectBox
              class="max-w-136"
              v-model="therapistInput"
              :placeholder="
                therapistSelectLoading ? 'Loading ...' : 'Select therapist'
              "
              :options="therapistOptions"
              emptyOptions="There are no therapists available for this client because they already have slots in different rooms. Please book through their available slots instead."
              search
              :disabled="therapist.id !== null"
              @change="onChangeTherapist"
            />
          </div>
          <div v-if="enableBranch" class="flex items-center gap-2">
            <BlIcon icon="location" color="slate-6" class="w-6 h-6" />
            <BlSelectBox
              class="max-w-136"
              type="branch"
              placeholder="Select branch"
              v-model="branchInput"
              :options="branchOptions"
              :disabled="room.id !== null"
              search
              @change="branchInput = $event"
            />
          </div>
          <div class="flex items-center gap-2">
            <BlIcon icon="door" color="slate-6" class="w-6 h-6" />
            <BlSelectBox
              class="max-w-136"
              v-model="roomInput"
              :placeholder="'Select room'"
              :options="roomOptions"
              search
              :disabled="room.id !== null"
              @change="onChangeRoom"
            />
          </div>
          <!-- <div class="flex items-center gap-2">
            <BlIcon icon="repeat" color="slate-6" class="w-6 h-6" />
            <BlSelectBox
              class="max-w-136"
              v-model="repeatInput"
              :options="repeatOptions"
              @change="onChangeRepeat($event)"
              :disabled="!clientInput || !timeInput.length"
            />
          </div> -->
          <!-- <div class="flex items-center gap-2">
            <BlIcon icon="calendar-x" color="slate-6" class="w-6 h-6" />
            <BlInputDate
              class="flex-grow"
              :input="{
                model:
                  repeatEndInput === 'on_date' && repeatInput.includes('custom')
                    ? endAfterInput
                    : '',
                disabled: true
              }"
            />
            <BlIcon icon="horizontal-arrow" color="slate-6" class="w-6 h-6" />
            <BlInputText
              class="flex-grow"
              :input="{
                inputType: 'number',
                model: repeatInput.includes('custom') ? occurrencesInput : 1,
                suffix: 'time(s)',
                disabled: true
              }"
            />
          </div> -->
          <div
            v-if="clientInput && timeInput.length > 0"
            class="py-2 px-3 flex flex-col gap-2 bg-cornflower-200 rounded"
          >
            <div class="flex items-center gap-2">
              <BlIcon icon="piggy" color="cornflower-8" class="h-6 w-6" />
              <BlTextSubtitle3
                text="Credits calculation"
                class="text-cornflower-800"
              />
            </div>
            <div class="flex flex-col gap-2">
              <BlTextBody2
                text="Credits will be deducted only after the session ends. However, please be aware of the remaining credits available when creating the appointment."
                class="text-cornflower-800"
              />
              <div class="flex flex-col gap-1">
                <div class="flex items-center justify-between gap-2">
                  <BlTextBody2
                    text="Credits used for this appointment(s)"
                    class="text-cornflower-800"
                  />
                  <div
                    class="rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                  >
                    <BlTextSubtitle3
                      :text="creditsUsed"
                      class="text-cornflower-200"
                    />
                  </div>
                </div>
                <div class="flex items-center justify-between gap-2">
                  <BlTextBody2
                    text="Projected remaining credits after this session(s) is completed"
                    class="text-cornflower-800"
                  />
                  <div
                    class="rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                  >
                    <BlTextSubtitle3
                      :text="remainingCredits"
                      class="text-cornflower-200"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="remainingCredits < 0"
            class="py-2 px-3 flex items-start gap-2 bg-tulip-100 rounded"
          >
            <BlIcon icon="warning" color="tulip-7" class="h-6 w-6" />
            <div class="flex flex-col">
              <BlTextBody2
                text="The credits available after this appointment will be negative. Please add credits to the client's account before creating the appointment."
                class="text-tulip-700"
              />
            </div>
          </div>
          <div
            v-if="unavailableDates.length"
            class="rounded flex items-start gap-2 py-2 px-3 bg-tulip-100"
          >
            <BlIcon icon="warning" color="tulip-7" class="h-6 w-6" />
            <div class="flex flex-col w-128">
              <BlTextBody2 :text="suffixError" class="text-tulip-700" />
              <div
                v-for="date in unavailableDates"
                :key="date"
                class="flex items-center gap-2 px-2"
              >
                <div class="rounded h-1 w-1 bg-tulip-700"></div>
                <BlTextBody2 :text="date" class="text-tulip-700" />
              </div>
              <BlTextBody2
                text="Please adjust the details to proceed with the availability."
                class="text-tulip-700"
              />
            </div>
          </div>
        </div>
        <div class="w-full h-5 bg-grey-100 mb-4" />
        <div class="px-8">
          <div
            class="flex items-center mb-2 cursor-pointer"
            @click="setAssignSupervisorsInput = !setAssignSupervisorsInput"
          >
            <div :style="{ transform: 'scale(1.375)' }" class="pl-2 pr-4">
              <BlInputToggle
                :checked="setAssignSupervisorsInput"
                @changed="
                  setAssignSupervisorsInput = !setAssignSupervisorsInput
                "
              />
            </div>
            <BlTextSubtitle1 text="Assign supervisor" />
          </div>
          <div class="flex mb-4">
            <BlTextBody2
              text="If you assign a supervisor, they will be able to view this appointment on their Sessions page without affecting their appointments and availability slots."
            />
          </div>
          <div v-if="setAssignSupervisorsInput" class="flex">
            <BlSearchBox
              type="user"
              placeholder="Select therapist"
              v-model="assignSupervisorsInput"
              :options="assignSupervisorOptions"
              @change="assignSupervisorsInput = $event"
              @search="fetchSupervisors"
              :searching="assignSupervisorsLoading"
              drop="up"
            />
          </div>
        </div>
      </div>
    </BlBackdrop>
    <RepeatDetailsModal
      v-if="repeatDetailsOpened"
      title="create"
      :current="{
        startDateInput: startDateInput.model,
        intervalInput,
        repetitionTypeInput,
        repeatEndInput,
        daysOfWeekInput,
        dayOfMonthInput,
        weekOfMonthInput,
        endAfterInput,
        occurrencesInput
      }"
      :availableCreditToUse="availableCreditToUse"
      :durationSlots="timeInput.length"
      @close-modal="repeatDetailsOpened = false"
      @on-submit="onChangeRepeatDetails"
    />
    <CreditLimitExceededModal
      v-if="creditLimitExceededOpened"
      :remainingCredits="remainingCredits"
      @close-modal="creditLimitExceededOpened = false"
      @on-submit="onSubmit"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CLOCK_HALF } from "@/plugins/assets.js";
import moment from "moment";

import RepeatDetailsModal from "./RepeatDetailsModal.vue";
import CreditLimitExceededModal from "./CreditLimitExceededModal.vue";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputDate from "../../BlInputDate.vue";
import BlSearchSelect from "../../BlSearchSelect.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import BlInputToggle from "../../BlInputToggle.vue";
import BlSearchBox from "../../BlSearchBox.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlSelectTimeslot from "../../BlSelectTimeslot.vue";

export default {
  name: "NewAppointmentsModal",
  components: {
    RepeatDetailsModal,
    CreditLimitExceededModal,
    BlBackdrop,
    BlTextTitle4,
    BlTextSubtitle1,
    BlTextSubtitle3,
    BlTextBody2,
    BlTextBody3,
    BlIcon,
    BlInputText,
    BlInputDate,
    BlSearchSelect,
    BlSelectBox,
    BlInputToggle,
    BlSearchBox,
    BlInputButton,
    BlSelectTimeslot
  },
  props: {
    availabilityId: { type: Number, default: 0 },
    therapist: { type: Object, default: null },
    room: { type: Object, default: null },
    startDate: { type: String, default: "" },
    startTime: { type: String, default: "" },
    endTime: { type: String, default: "" },
    isOpenRoom: { type: Boolean, default: false },
    availableSlots: { default: () => [] }
  },
  data() {
    return {
      submitLoading: false,
      creditLimitExceededOpened: false,
      clientInput: null,
      clientDataInput: null,
      therapistSelectLoading: false,
      therapistInput: null,
      therapistOptions: [],
      startDateInput: { model: "", disabled: true },
      timeSelectLoading: false,
      timeInput: [],
      //
      branchInput: 0,
      roomInput: null,
      repeatInput: "not_repeat",
      //
      repeatDetailsOpened: false,
      customized: false,
      //
      intervalInput: "1",
      repetitionTypeInput: "week", // day | week | month | year
      repeatEndInput: "never", // never | on_date | after_occurrences
      //
      daysOfWeekInput: [], // (monday | tuesday | wednesday | thursday | friday | saturday | sunday)[]
      dayOfMonthInput: null, // 1 - 31 (day)
      weekOfMonthInput: null, // first, second, third, fourth, last (week)
      //
      endAfterInput: "",
      occurrencesInput: "",
      unavailableDates: [],
      setAssignSupervisorsInput: false,
      assignSupervisorsLoading: false,
      assignSupervisorsInput: [],
      assignSupervisorOptions: [],
      clockHalf: CLOCK_HALF
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentCenter",
      "branches",
      "availabilityRooms",
      "availabilityTimeslots"
    ]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    branchOptions() {
      const allBranch = {
        value: 0,
        label: "All branches",
        class: "-mx-2"
      };
      const arr = this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
      const noBranch = {
        value: "no",
        label: "No branch",
        color: "#667085",
        backgroundColor: "#F9FAFB"
      };
      return [allBranch, ...arr, noBranch];
    },
    roomOptions() {
      let rooms = [...this.availabilityRooms];
      if (this.enableBranch && this.branchInput) {
        rooms = rooms.filter(i => {
          if (this.branchInput === "no") return !i.branch_id;
          return i.branch_id === this.branchInput;
        });
      }

      const arr = rooms.map(i => {
        let branch = "";
        if (this.enableBranch && !this.branchInput && i.branch_id) {
          branch = `
            <div
              class="max-w-32 h-7 -mx-4 px-2 flex items-center justify-center rounded truncate"
              style="background-color: ${i.branch.background_color || "unset"}"
            >
              <span
                class="text-sm truncate"
                style="color: ${i.branch.color || "unset"}"
              >${i.branch.name}</span>
            </div>
          `;
        }
        return {
          value: i.id,
          label: i.name,
          suffix: branch
        };
      });
      if (this.room && this.room.id) {
        return [{ value: this.room.id, label: this.room.name }];
      }
      return arr;
    },
    timeOptions() {
      const arr = this.availabilityTimeslots.map(i => ({
        value: i.start_time_string,
        disabled: i.is_booked
      }));
      if (this.isOpenRoom) {
        const arrProps = [...this.availableSlots].map(i => ({
          value: i.start_time_string,
          disabled: i.is_booked
        }));
        return arrProps;
      }
      return arr;
    },
    repeatOptions() {
      const arr = [{ value: "not_repeat", label: `Doesn't repeat` }];
      if (this.customized) {
        const collectiveTerms = {
          day: "Daily",
          week: "Weekly",
          month: "Monthly",
          year: "Annually"
        };
        const repeatNumber =
          this.intervalInput > 1
            ? `Every ${this.intervalInput} ${this.repetitionTypeInput}s`
            : collectiveTerms[this.repetitionTypeInput];

        let onDays = "";
        if (this.daysOfWeekInput.length) {
          onDays = ` on ${this.daysOfWeekInput.join(", ")}`;
        }
        const onDate = ` on day ${this.dayOfMonthInput}`;
        const ordinals = {
          first: "1st",
          second: "2nd",
          third: "3rd",
          fourth: "4th",
          last: "5th"
        };
        const dayOfWeek = moment(this.startDateInput.model).format("ddd");
        const onWeek = ` on ${ordinals[this.weekOfMonthInput]} ${dayOfWeek}`;
        const onMonthDate = ` on ${moment(this.startDateInput.model).format(
          "MMM DD"
        )}`;
        const repeatOn = {
          day: "",
          week: onDays,
          month: this.dayOfMonthInput ? onDate : onWeek,
          year: onMonthDate
        };

        const label = `${repeatNumber}${repeatOn[this.repetitionTypeInput]}`;
        arr.push({ value: "customized", label });
      }
      arr.push({ value: "custom", label: `Custom...` });
      return arr;
    },
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      if (!this.clientInput) return true;
      if (!this.therapistInput) return true;
      if (!this.timeInput.length) return true;
      if (!this.roomInput) return true;
      if (this.remainingCredits < 0) return true;
      return false;
    },
    availableCredits() {
      if (!this.clientInput) return 0;
      if (!this.clientDataInput) return 0;
      if (!this.clientDataInput.credit_detail) return 0;
      const available = this.clientDataInput.credit_detail.session_credits
        .available;
      const scheduled =
        this.clientDataInput.credit_detail.scheduled_credits.total_credits || 0;
      return available - scheduled;
    },
    availableCreditToUse() {
      const subs = this.availableCredits % this.timeInput.length;
      return this.availableCredits - subs;
    },
    creditsUsed() {
      if (this.repeatInput.includes("custom")) {
        if (this.repeatEndInput === "never") return this.availableCreditToUse;
        else return this.occurrencesInput * this.timeInput.length;
      } else return this.timeInput.length;
    },
    remainingCredits() {
      if (!this.clientInput) return 0;
      if (!this.clientDataInput) return 0;
      return this.availableCredits - this.creditsUsed;
    },
    suffixError() {
      let text = "Slot";
      const therapist = this.therapistOptions.find(
        i => i.value === this.therapistInput
      ) || { label: "Slot" };

      text = therapist.label;
      const start = this.timeInput[0];
      const idx = this.clockHalf.indexOf(
        this.timeInput[this.timeInput.length - 1]
      );
      const end = this.clockHalf[idx + 1];
      text += ` isn't available for the selected timeslot (${start} - ${end}) on the following day(s):`;
      return text;
    }
  },
  watch: {
    branchInput(val) {
      if (this.enableBranch && val) {
        this.roomInput = null;
      }
    }
  },
  async mounted() {
    if (this.therapist && this.therapist.id) {
      this.therapistInput = this.therapist.id;
    }
    if (this.room && this.room.id) {
      if (this.room.branch) {
        this.branchInput = this.room.branch.id;
      } else this.branchInput = "no";
      setTimeout(() => {
        this.roomInput = this.room.id;
      }, 10);
    }
    if (this.startDate) {
      this.startDateInput.model = this.startDate;
    } else {
      this.startDateInput.disabled = false;
    }
    if (this.startTime) this.timeInput = [this.startTime];

    await this.getUsers({
      search: true,
      params: "?sort=name_asc&status=active"
    }).then(({ success, data }) => {
      if (!success) return;
      if (this.isOpenRoom) return;
      const arr = data.map(i => ({ value: i.id, label: i.name }));
      if (this.therapist && this.therapist.id) {
        const found = data.find(i => i.id === this.therapist.id);
        if (!found) {
          arr.unshift({ value: this.therapist.id, label: this.therapist.name });
        }
      }
      this.therapistOptions = arr;
    });

    await this.fetchTimeslots();
  },
  methods: {
    ...mapActions([
      "getClient",
      "getUsers",
      "getTimeslots",
      "getTherapistisOpenRoom",
      "getSupervisors",
      "createRecurringAppointments"
    ]),
    fetchSupervisors(val = "") {
      this.assignSupervisorsLoading = true;
      let params = `?sort=alphabetical&status=active`;
      if (val) params += `&query=${val}`;
      if (this.clientInput) {
        params += `&client_id=${this.clientInput}`;
      }
      this.getSupervisors({ params }).then(({ success, data }) => {
        this.assignSupervisorsLoading = false;
        if (!success) return;
        this.assignSupervisorOptions = data
          .map(i => ({ value: i.id, label: i.name }))
          .filter(i => i.value !== this.therapistInput);
      });
    },
    fetchTherapistsisOpenRoom() {
      this.therapistSelectLoading = true;
      let params = `?date=${this.startDateInput.model}&room_id=${this.roomInput}`;
      if (this.clientInput) {
        params += `&client_id=${this.clientInput}`;
      }
      if (this.timeInput.length > 0) {
        const start = this.timeInput[0];
        const idx = this.clockHalf.indexOf(
          this.timeInput[this.timeInput.length - 1]
        );
        const end = this.clockHalf[idx + 1];
        params += `&start_time=${start}&end_time=${end}`;
      }
      this.therapistOptions = [];
      this.getTherapistisOpenRoom({ params }).then(({ success, data }) => {
        this.therapistSelectLoading = false;
        if (!success) return;
        const arr = data.map(i => ({ value: i.id, label: i.name }));
        this.therapistOptions = arr;
      });
    },
    fetchTimeslots() {
      this.timeSelectLoading = true;
      let params = `?type=daily`;
      if (this.therapistInput) {
        params += `&user_id=${this.therapistInput}`;
      }
      if (this.startDateInput.model) {
        params += `&date=${this.startDateInput.model}`;
      }
      if (this.roomInput) {
        params += `&room_id=${this.roomInput}`;
      }
      return this.getTimeslots({ availability: true, params }).then(() => {
        this.timeSelectLoading = false;
      });
    },
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    },
    async onChangeClient(val) {
      this.clientInput = val;
      if (val) {
        const { success, data } = await this.getClient({ id: val });
        if (success) this.clientDataInput = data;
      } else this.clientDataInput = null;

      if (this.isOpenRoom) {
        this.therapistInput = null;
        this.fetchTherapistsisOpenRoom();
      }
    },
    onChangeTherapist(val) {
      this.therapistInput = val;
      this.assignSupervisorsInput = this.assignSupervisorsInput.filter(
        i => i !== val
      );
      if (!this.isOpenRoom) {
        this.timeInput = [];
        this.fetchTimeslots();
      }
    },
    onChangeDate(payload) {
      this.startDateInput.model = payload.value;
      if (!this.isOpenRoom) {
        this.timeInput = [];
        this.fetchTimeslots();
      } else {
        this.therapistInput = null;
        this.fetchTherapistsisOpenRoom();
      }
    },
    onChangeTimeSlot(val) {
      this.timeInput = val;
      if (this.isOpenRoom) {
        this.therapistInput = null;
        this.fetchTherapistsisOpenRoom();
      }
    },
    onChangeRoom(val) {
      this.roomInput = val;
      if (!this.isOpenRoom) {
        this.timeInput = [];
        this.fetchTimeslots();
      }
    },
    onChangeRepeat(val) {
      this.repeatInput = val;
      if (val === "custom") this.repeatDetailsOpened = true;
    },
    onChangeRepeatDetails(val) {
      this.customized = true;
      this.repeatInput = "customized";
      //
      this.intervalInput = val.intervalInput;
      this.repetitionTypeInput = val.repetitionTypeInput; // day | week | month | year
      this.repeatEndInput = val.repeatEndInput; // never | on_date | after_occurrences
      //
      this.daysOfWeekInput = val.daysOfWeekInput; // (monday | tuesday | wednesday | thursday | friday | saturday | sunday)[]
      this.dayOfMonthInput = val.dayOfMonthInput; // 1 - 31 (day)
      this.weekOfMonthInput = val.weekOfMonthInput; // first, second, third, fourth, last (week)
      //
      this.endAfterInput = val.endAfterInput;
      this.occurrencesInput = val.occurrencesInput;
    },
    onNext() {
      // if (this.remainingCredits < 0) this.creditLimitExceededOpened = true;
      // else this.onSubmit();
      this.onSubmit();
    },
    async onSubmit() {
      const start = this.timeInput[0];
      const idx = this.clockHalf.indexOf(
        this.timeInput[this.timeInput.length - 1]
      );
      const end = this.clockHalf[idx + 1];

      const appointment = {
        client_id: this.clientInput,
        user_id: this.therapistInput,
        room_id: this.roomInput,
        start_date: this.startDateInput.model,
        start_time: start,
        end_time: end,
        //
        // interval: null,
        // repetition_type: "not_repeat",
        // days_of_week: [],
        // day_of_month: null,
        // week_of_month: null,
        // end_after: null,
        // occurrences: null,
        //
        supervisor_ids: this.setAssignSupervisorsInput
          ? this.assignSupervisorsInput
          : [],
        availability_id: this.availabilityId
      };

      if (this.repeatInput.includes("custom")) {
        appointment.interval = this.intervalInput;
        appointment.repetition_type = this.repetitionTypeInput;
        if (this.repetitionTypeInput === "week") {
          appointment.days_of_week = this.daysOfWeekInput;
        }
        if (this.repetitionTypeInput === "month") {
          if (this.dayOfMonthInput) {
            appointment.day_of_month = this.dayOfMonthInput;
          }
          if (this.weekOfMonthInput) {
            appointment.week_of_month = this.weekOfMonthInput;
          }
        }
        if (this.repeatEndInput === "on_date") {
          appointment.end_after = this.endAfterInput;
        }
        if (
          this.repeatEndInput === "never" ||
          this.repeatEndInput === "after_occurrences"
        ) {
          appointment.occurrences = this.occurrencesInput;
        }
      }

      const params = {
        params: {
          recurring_appointment: appointment
        },
        title: null,
        message: null
      };

      this.unavailableDates = [];
      this.creditLimitExceededOpened = false;

      this.submitLoading = true;
      const payload = await this.createRecurringAppointments(params);
      const {
        success,
        unavailable_timeslots: timeslots,
        unavailable_therapist: therapists
      } = payload;

      if (!success) {
        this.submitLoading = false;
        const format = "DD MMM YYYY";
        const arrError = [...timeslots, ...therapists];
        this.unavailableDates = arrError.map(i => {
          const d = moment(i.date, "YYYY-MM-DD").format(format);
          return `${d}, ${i.start_time} - ${i.end_time}`;
        });
        return;
      }

      setTimeout(() => {
        this.submitLoading = false;
        this.$emit("after-commit");
        this.$emit("close-modal");
      }, 1000);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/modal/NewAppointmentsModal.vue